/* eslint-disable no-new */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';
import VModal from 'vue-js-modal';
import VueLazyload from 'vue-lazyload';

import ArticleShowComponent from '../components/article/ArticleShow.vue';
import messages from '../lang/index';

import Viewer from 'viewerjs';

Vue.use(VueApollo);
Vue.use(VueI18n);
Vue.use(VModal);
Vue.use(VueLazyload, {
  lazyComponent: true,
});

Vue.prototype.$isMobile = window.screen.width <= 599;
Vue.prototype.$isDesktop = window.screen.width > 599;

const csrfToken = document.head.querySelector('[name=csrf-token]').content;

const apolloProvider = new VueApollo({
  defaultClient: new ApolloClient({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-TOKEN': csrfToken,
    },
  }),
});

document.addEventListener('DOMContentLoaded', () => {
  const thresholdRate = 0.8;
  const loadArticle = () => {
    // load article when scroll to the bottom
    if ($(window).scrollTop() + $(window).height() >= $(document).height() * thresholdRate) {
      const allData = document.getElementById('allData').dataset;
      const props = {
        articleId: allData.article,
        articleSlug: allData.articleSlug,
        locale: allData.locale,
      };

      const supportedLocales = ['en', 'cn'];
      let locale = props.locale;
      if (!supportedLocales.includes(locale)) {
        locale = 'en';
      }

      const i18n = new VueI18n({
        locale,
        fallbackLocale: 'en',
        messages,
      });

      new Vue({
        el: 'app',
        apolloProvider,
        i18n,
        render: h => h(ArticleShowComponent, { props }),
      });
      $(window).off('scroll');
      $('.next-article-loader-show').css('display', 'none');
    }
  }

  const controlAudio = () => {
    const container = document.querySelector('.audio-player-container .audio-player-wrap');
    const audio = document.querySelector('.audio-src');
    const seekSlider = document.querySelector('.seek-slider');
    const totalTime = document.querySelector('.total-time');
    const playBtn = document.querySelector('.play-btn');
    const playBtnMobile = document.querySelector('.play-btn-mobile');
    // Show total time

    const duration = Number(audio.duration);

    // Toogle play button when audio ended
    audio.addEventListener('ended', function() {
      playBtnMobile.children[0].classList.remove('fa-pause')
      playBtnMobile.children[0].classList.add('fa-play')

      playBtn.children[0].classList.remove('fa-pause')
      playBtn.children[0].classList.add('fa-play')
      container.classList.remove('show');
    });

    const setCurrentTime = (currentTime) => {
      audio.currentTime = currentTime;
    };

    const getAudioProgress = (currentTime) => {
      const progress = currentTime / duration * 100;
      seekSlider.value = progress;
      return progress;
    };

    // Highlight timeline run
    const markSlider = (value, slider) => {
      slider.style.background =  'linear-gradient(to right, #E64326 0%, #E64326 ' + value + '%, #aaa ' + value + '%, #aaa 100%)'
    };

    const timeConvert = (time) => {
      if (!time) return null;

      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      const secondsFormat = seconds < 10 ? `0${seconds}` : seconds;

      return `${minutes}:${secondsFormat}`;
    };

    totalTime.innerText = timeConvert(duration);

    // Control audio
    const playAudio = (button) => {
      if (container.className.includes('show')) {
        audio.pause();
      } else {
        audio.play();
      }
      button.children[0].classList.toggle('fa-pause');
      button.children[0].classList.toggle('fa-play');
      container.classList.toggle('show');
    };

    // Move play head
    audio.addEventListener('timeupdate', (e) => {
      const currentTime = e.target.currentTime;
      getAudioProgress(currentTime);
      markSlider(currentTime * 100 / duration, seekSlider);
    });

    // Drag play head
    seekSlider.addEventListener('input', (e) => {
      const progress = parseInt(e.target.value);
      const time = progress / 100 * duration;
      setCurrentTime(time);
      getAudioProgress(time, duration);
    });


    if (window.innerWidth > 768) {
      const volumeSlider = document.querySelector('.volume-slider');
      const muteBtn = document.querySelector('.mute-btn');

      const muteAudio = () => {
        if (audio.muted) {
          audio.muted = false;
        } else {
          audio.muted = true;
        }
        muteBtn.children[0].classList.toggle('fa-volume-up');
        muteBtn.children[0].classList.toggle('fa-volume-mute');
      };

      playBtn.onclick = () => {
        playAudio(playBtn);
      };

      muteBtn.onclick = () => {
        muteAudio();
      };

      volumeSlider.addEventListener('input', (e) => {
        const value = e.target.value;
        const volume = value / 100;
        audio.volume = volume;
        markSlider(value, e.target)
      });
    } else {
      const forwardBtn = document.querySelector('.forward-btn');
      const rewindBtn = document.querySelector('.rewind-btn');

      playBtnMobile.onclick = () => {
        playAudio(playBtnMobile);
      };

      forwardBtn.onclick = () => {
        audio.currentTime += 15;
      };

      rewindBtn.onclick = () => {
        audio.currentTime -= 15;
      };
    }
  }

  if ($('.audio-player-container audio').length > 0) { // Check audio exist
    window.addEventListener('load', controlAudio);
  }

  $(window).on('scroll', loadArticle);

  //enlarge the photo
  new Viewer(document.getElementById('zoom-images'), {
    toolbar: {
      zoomIn: 2,
      zoomOut: 2,
      oneToOne: 2,
      reset: 2,
      prev: 0,
      play: 0,
      next: 0,
      rotateLeft: 2,
      rotateRight: 2,
      flipHorizontal: 2,
      flipVertical: 2,
    },
  });

  let isUserLoggedIn = document.getElementById('isUserLoggedIn').value === "true";
  let isArticleRead = document.getElementById('isArticleRead').value === "true";
  
  //Track the article's reading progress
  const progressBar = document.querySelector('.progress-bar');
  const progress = document.querySelector('.progress');
  const readTime = document.querySelector('.read-time');
  const paragraphs = document.querySelectorAll('.article__content p');
  const pointStart = document.querySelector('.flag-start');
  const pointEnd = document.querySelector('.flag-end');
  const content = document.querySelector('.content-middle');
  const isMobile = window.innerWidth < 768;
  const threshold = isMobile ? 66 : 54;
  let roundedReadTime = 0;
  let windowHeight = window.innerHeight;

  const pointArticle = document.querySelector('#point');

  //flag
  let hasTimeEnded = false;
  let hasCompleted = false;
  let counting = false;
  let addPoint = false;
  let isScrollEventActive = true;
  let isLeftActive = true;

  if (isUserLoggedIn) {
    let readArticleIds = JSON.parse(document.getElementById('readArticleIds').value);
    let pointText = readArticleIds > 0
                          ? '+120 BWP'
                          : '+100 BWP';
    const textPointElements = document.querySelectorAll('.text-point');      
    
    //content in track
    textPointElements.forEach(element => {
      element.innerHTML = pointText;
    });
  }

  const leftContent = document.querySelector('.left-content');
  const leftTime = document.querySelector('.left-time');
  const mobileTime = document.querySelector('.mobile-time');


  handleReadTimeArticle();

  let secondsRemaining = roundedReadTime * 60;

  function handleScrollArticle() {
    const rectStart = pointStart.getBoundingClientRect();
    const rectEnd = pointEnd.getBoundingClientRect();
    const articleContentHeight = rectEnd.top - rectStart.top;
    let scrollHeight = windowHeight - (rectStart.top + 500); 


    if ( scrollHeight >= articleContentHeight) {
      scrollHeight = articleContentHeight
    }

    let scrollPercentage = (scrollHeight/articleContentHeight) * 100;

    if (scrollPercentage <= threshold) {
      content.style.color = "black";
    } else {
      content.style.color = "white";
    }
    progress.style.width = scrollPercentage + '%';

    if (isUserLoggedIn) {
      if (!isArticleRead) {
        hasCompleted = (scrollPercentage == 100)
      
        if (!counting) {
          counting = true
          setTimeout(function () {
            hasTimeEnded = true;
          }, roundedReadTime * 60 * 1000);
        }
  
        if (hasTimeEnded && hasCompleted && !addPoint) {
          addPoint = true;
          sendReadRequest();
        }
      } else {
        progress.style.width = '100%';
        pointArticle.innerHTML = "Congratulations, you have received rewards from this article";
      }
    }
  }

  function handleReadTimeArticle() {
    let totalWords = 0;

    paragraphs.forEach(function(paragraph) {
      var words = paragraph.textContent.split(/\s+/).filter(function(word) {
          return word.length > 0;
      });
      totalWords += words.length;

      let minReadTime = totalWords/200;
      roundedReadTime = minReadTime > Math.floor(minReadTime) + 0.5 ? Math.ceil(minReadTime) : Math.floor(minReadTime);
      roundedReadTime = roundedReadTime === 0 ? 1 : roundedReadTime;

      readTime.innerHTML = roundedReadTime + (roundedReadTime > 1 ? ' mins ' : ' min ');
    });
  }

  window.addEventListener('scroll', function () {
    const rectStart = pointStart.getBoundingClientRect();

    if (isUserLoggedIn) {
      if (!isScrollEventActive) {
        return;
      }
      const rectEnd = pointEnd.getBoundingClientRect();
  
      if (rectEnd.top <= windowHeight && addPoint) {
        console.log("end");
        showCongratulation();
        isScrollEventActive = false;
        return;
      } 
  
      if (rectStart.top <= 450) {
        if (isLeftActive) {
          countdown();
          setTimeout(updateLeftText, 5000);
          isLeftActive = false;
        }
        progressBar.classList.add("active-track");
        handleScrollArticle();
      }
  
      if (rectStart.top > 450) {
        progressBar.classList.remove("active-track");
      }
    } else {
      if (rectStart.top <= 425) {
        progressBar.classList.add("active-track");
        handleScrollArticle();
      }
  
      if (rectStart.top > 425) {
        progressBar.classList.remove("active-track");
      }
    }
  });

  function updateCountdown() {
    const minutesElements = document.querySelectorAll('.minutes');
    const secondsElements = document.querySelectorAll('.seconds');

    const minutes = Math.floor(secondsRemaining / 60);
    const seconds = secondsRemaining % 60;

    minutesElements.forEach(element => {
      element.textContent = minutes < 10 ? '0' + minutes : minutes;
    });
    secondsElements.forEach(element => {
      element.textContent = seconds < 10 ? '0' + seconds : seconds;
    });
  }

  function countdown() {
    if (!isArticleRead) {
      updateCountdown();

      if (secondsRemaining > 0) {
        secondsRemaining--;
        setTimeout(countdown, 1000);
      } else {
        leftTime.innerHTML = "TIMER ENDED";
        mobileTime.innerHTML = "Timer ended"
        setTimeout( function () {
          leftTime.classList.remove("active-left");
        }, 5000); 
      }
    }
  }

  function updateLeftText() {
    if (secondsRemaining > 0) {
      leftContent.classList.remove("active-left");
      leftTime.classList.add("active-left"); 
    }
  }

  function showCongratulation() {
    let eleCongratulation = document.querySelector('.congratulation');
    eleCongratulation.classList.add('active-congratulation');

    setTimeout(function() {
      eleCongratulation.classList.remove('active-congratulation');
    }, 3000);
  }

  function sendReadRequest() {
    let currentURL = window.location.pathname;

    fetch(currentURL + '/read', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
    })
    .then(response => {
      if (response.ok) {
        effectAddPoint();
      }
      return response.json();
    })
    .then(data => {
      if (data.message) {
        pointArticle.innerHTML = 'Congratulations on receiving ' + data.message;
        pointArticle.style.color = "white";
      }
    })
    .catch(error => {
      console.error('Error sending read request:', error);
    });
  }

  function effectAddPoint() {
    progressBar.classList.add('active-add-point');
    pointArticle.classList.add('visible-ele');
    setTimeout(function() {
      progressBar.classList.remove('active-add-point');
      pointArticle.classList.remove('visible-ele');
    }, 3500);
  }

});